import { createSearchParams, NavLink } from 'react-router-dom';
import '../App.css'

function Plan(props) {
    const styles = {
        infoBox: {
            border: '1px solid #c8c8c8',
            borderColor: '#c8c8c8',
            borderRadius: '10px',
            margin: '20px',
        },
        planName: {
            fontSize: '40px',
            textDecoration: 'none',
            margin: '0px',
            paddingRight: '20px',
            borderRight: '1px solid #c8c8c8'
        },
        planData: {
            fontSize: '30px',
            textDecoration: 'none',
            paddingRight: '20px',
            borderRight: '1px solid #c8c8c8',
            margin: '0px'
        },
        carrier: {
    
        },
        planInfo: {
            fontWeight: '500',
            margin: '0px'
        },
        planPromo: {
            margin: '0px',
            padding: '10px'
        }
    }
    return (
        <>
            <NavLink to={{ pathname: '/infoform', search: createSearchParams({ carrier: props.carrier, plan: props.planName, promo: props.planPromo, speed: props.speed }).toString() }} style={{ textDecoration: 'none', color: 'black', fontSize: '20px', textAlign: 'center', fontWeight: 'bold'}}>
                <div style={styles.infoBox}>
                    <div style={{display: 'flex', flexWrap:'wrap', alignItems: 'center', gap: '20px', justifyContent: 'center', borderBottom: '1px solid #c8c8c8', padding: '20px'}} >
                        <p style={styles.planName}>{props.planName}<small>/mo.</small></p>
                        <p style={styles.planData}>{props.planData}</p>
                        <p style={styles.planData}>{props.speed}</p>
                        <p style={styles.planInfo}>{props.planInfo}</p>
                    </div>
                    <div>
                        <p style={styles.planPromo}>{props.planPromo}</p>
                    </div>
                </div>

            </NavLink>
        </>
    )
}

export default Plan;